import {
  FETCH_TRANS_PENDING,
  FETCH_TRANS_REJECTED,
  FETCH_TRANS_FULFILLED,
  FETCH_TOUR_STATUS_PENDING,
  FETCH_TOUR_STATUS_REJECTED,
  FETCH_TOUR_STATUS_FULFILLED,
  FETCH_FIXTURES_PENDING,
  FETCH_FIXTURES_REJECTED,
  FETCH_FIXTURES_FULFILLED,
  FETCH_USER_PLAYED_GAMEDAYS_PENDING,
  FETCH_USER_PLAYED_GAMEDAYS_REJECTED,
  FETCH_USER_PLAYED_GAMEDAYS_FULFILLED,
  FETCH_MTACH_QUESTIONS_PENDING,
  FETCH_MTACH_QUESTIONS_REJECTED,
  FETCH_MTACH_QUESTIONS_FULFILLED,
  FETCH_MTACH_USER_ANSWER_PENDING,
  FETCH_MTACH_USER_ANSWER_REJECTED,
  FETCH_MTACH_USER_ANSWER_FULFILLED,
  POST_MTACH_USER_ANSWER_PENDING,
  POST_MTACH_USER_ANSWER_REJECTED,
  POST_MTACH_USER_ANSWER_FULFILLED,
  POST_MTACH_USER_BOOSTER_PENDING,
  POST_MTACH_USER_BOOSTER_REJECTED,
  POST_MTACH_USER_BOOSTER_FULFILLED,
  FETCH_MTACH_USER_POINTS_PENDING,
  FETCH_MTACH_USER_POINTS_REJECTED,
  FETCH_MTACH_USER_POINTS_FULFILLED,
  FETCH_CONTRAINTS_PENDING,
  FETCH_CONTRAINTS_REJECTED,
  FETCH_CONTRAINTS_FULFILLED,
  FETCH_MIX_PENDING,
  FETCH_MIX_REJECTED,
  FETCH_MIX_FULFILLED,
  FETCH_LEADERBOARD_PENDING,
  FETCH_LEADERBOARD_REJECTED,
  FETCH_LEADERBOARD_FULFILLED,
  FETCH_LEADERBOARD_RANK_PENDING,
  FETCH_LEADERBOARD_RANK_REJECTED,
  FETCH_LEADERBOARD_RANK_FULFILLED,
  FETCH_BALANCE_PENDING,
  FETCH_BALANCE_REJECTED,
  FETCH_BALANCE_FULFILLED,
  POST_CREATE_LEAGUE_PENDING,
  POST_CREATE_LEAGUE_REJECTED,
  POST_CREATE_LEAGUE_FULFILLED,
  POST_JOIN_LEAGUE_PENDING,
  POST_JOIN_LEAGUE_REJECTED,
  POST_JOIN_LEAGUE_FULFILLED,
  CHANGE_SELECTED_FIXTURE,
  SET_DATA_AFTER_POST,
  SET_DATA_ALERT,
  CLEAR_DATA_QUESTIONS,
  SET_WRAPPER_REF,
  POST_LOGIN_PENDING,
  POST_LOGIN_REJECTED,
  POST_LOGIN_FULFILLED,
  UPDATE_QUESTION_STATUS,
} from "./../../actionTypes";
import config from "./../../../common/config";
import core from "./../../../common/core";
import app from "./../../../common/app";

const initialState = {
  jStatusQuestionId: 0,
  sportId: 1,
  isGameStatus: config.enumGameStatus.open,
  isLoading: false,
  isTransLoading: false,
  isTransError: false,
  isTransSuccess: false,
  trans: {},
  isTourStatusLoading: false,
  isTourStatusError: false,
  isTourStatusSuccess: false,
  tourStatus: null,
  jErrorcode: config.enumErrorCode.normal,
  //
  isFixturesLoading: false,
  isFixturesError: false,
  isFixturesSuccess: false,
  arrFixtures: [],
  jFixtures: 0,
  //
  isQuestionsLoading: false,
  isQuestionsError: false,
  isQuestionsSuccess: false,
  arrQuestions: [],
  //
  isUsersAnswersLoading: false,
  isUsersAnswersError: false,
  isUsersAnswersSuccess: false,
  objUsersAnswers: null,
  //
  isPostUsersAnswersLoading: false,
  isPostUsersAnswersError: false,
  isPostUsersAnswersSuccess: false,
  objPostUsersAnswers: null,
  //
  isPostUsersBoosterLoading: false,
  isPostUsersBoosterError: false,
  isPostUsersBoosterSuccess: false,
  objPostUsersBooster: null,
  //
  isPostCreateLeagueLoading: false,
  isPostCreateLeagueError: false,
  isPostCreateLeagueSuccess: false,
  objPostCreateLeague: null,
  //
  isPostJoinLeagueLoading: false,
  isPostJoinLeagueError: false,
  isPostJoinLeagueSuccess: false,
  objPostJoinLeague: null,
  //
  isUserPlayedGameDaysLoading: false,
  isUserPlayedGameDaysError: false,
  isUserPlayedGameDaysSuccess: false,
  objUserPlayedGameDays: null,
  //
  isContraintsLoading: false,
  isContraintsError: false,
  isContraintsSuccess: false,
  objContraints: null,
  //
  isMixLoading: false,
  isMixError: false,
  isMixSuccess: false,
  objMix: null,
  //
  isUserPointsLoading: false,
  isUserPointsError: false,
  isUserPointsSuccess: false,
  objUserPoints: null,
  //alert
  propsAlert: { isShow: false, message: "" },
  //
  isLeaderboardLoading: false,
  isLeaderboardError: false,
  isLeaderboardSuccess: false,
  arrLeaderboard: [],
  //
  isLeaderboardRankLoading: false,
  isLeaderboardRankError: false,
  isLeaderboardRankSuccess: false,
  arrLeaderboardRank: [],
  //
  isUserBalanceLoading: false,
  isUserBalanceError: false,
  isUserBalanceSuccess: false,
  objUserBalance: [],
  //
  refWrapper: null,
  //
  isLoginLoading: false,
  isLoginError: false,
  isLoginSuccess: false,
  objLogin: null,
  //
  currQuestId: null,
};

export default function appData(state = initialState, action) {
  switch (action.type) {
    /** START API */
    ////////////////get//////////////////////
    case FETCH_TRANS_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isLoading: true,
        isTransLoading: true,
        isTransError: false,
        isTransSuccess: false,
      };
    }
    case FETCH_TRANS_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isLoading: false,
        isTransLoading: false,
        isTransError: true,
        isTransSuccess: false,
      };
    }
    case FETCH_TRANS_FULFILLED: {
      let trans = null;
      if (action.payload.data && action.payload.data.value) {
        trans = action.payload.data.value.Translations;
      }
      //core.setLoader();
      return {
        ...state,
        isLoading: false,
        isTransLoading: false,
        isTransError: false,
        isTransSuccess: true,
        trans: trans,
      };
    }
    //

    case FETCH_TOUR_STATUS_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isLoading: true,
        isTourStatusLoading: true,
        isTourStatusError: false,
        isTourStatusSuccess: false,
      };
    }
    case FETCH_TOUR_STATUS_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isLoading: false,
        isTourStatusLoading: false,
        isTourStatusError: true,
        isTourStatusSuccess: false,
      };
    }
    case FETCH_TOUR_STATUS_FULFILLED: {
      let tourStatus = null;
      if (action?.payload?.data?.Meta?.RetVal) {
        tourStatus = action?.payload?.data?.Data?.Value;
      }
      //core.setLoader();
      return {
        ...state,
        isLoading: false,
        isTourStatusLoading: false,
        isTourStatusError: false,
        isTourStatusSuccess: true,
        tourStatus: tourStatus,
      };
    }
    //

    case FETCH_FIXTURES_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isFixturesLoading: false,
        isFixturesError: false,
        isFixturesSuccess: false,
      };
    }
    case FETCH_FIXTURES_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isFixturesLoading: false,
        isFixturesError: true,
        isFixturesSuccess: false,
      };
    }
    case FETCH_FIXTURES_FULFILLED: {
      let totalMatches = 0;
      let isShowPlayerStats = false;
      let { jFixtures, arrFixtures: arrFixturesT } = state;
      let arrFixtures = [...arrFixturesT];
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        arrFixtures = action.payload.data.Data.Value;
        totalMatches = arrFixtures.length;
        const arrResultFixtures = arrFixtures.map((ele, jIndex) => {
          return { ...ele };
        });
        let groupedFixtures = arrResultFixtures; //app.generateFixtureArray(arrResultFixtures);
        return {
          ...state,
          isFixturesLoading: false,
          isFixturesError: false,
          isFixturesSuccess: true,
          arrFixtures: groupedFixtures,
          jFixtures: jFixtures,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          isFixturesLoading: false,
          isFixturesError: false,
          isFixturesSuccess: true,
        };
      }
    }

    case FETCH_MTACH_QUESTIONS_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isQuestionsLoading: true,
        isQuestionsError: false,
        isQuestionsSuccess: false,
      };
    }
    case FETCH_MTACH_QUESTIONS_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isQuestionsLoading: false,
        isQuestionsError: true,
        isQuestionsSuccess: false,
      };
    }
    case FETCH_MTACH_QUESTIONS_FULFILLED: {
      const { jMdStatus } = action.meta || {};
      let arrQuestions = [];
      /* action.payload.data = {
          "data": {
            "value": [
              {
                "matchId": 1,
                "tourId": 11125,
                "questionId": 7,
                "sportId": 1,
                "sportFormat": "cricket",
                "questionDesc": "Number of Sixes in the match",
                "questionType": "RNG",
                "questionLevel": 1,
                "questionOptionType": "",
                "isMandatory": 1,
                "status": 1,
                "options": [
                  {
                    "questionId": 7,
                    "optionId": 4,
                    "optionDesc": "0-5",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 7,
                    "optionId": 5,
                    "optionDesc": "6-10",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 7,
                    "optionId": 6,
                    "optionDesc": "11-15",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 7,
                    "optionId": 7,
                    "optionDesc": "16 & above",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  }
                ]
              },
              {
                "matchId": 1,
                "tourId": 11125,
                "questionId": 10,
                "sportId": 1,
                "sportFormat": "cricket",
                "questionDesc": "Predict the total runs scored in the match",
                "questionType": "RNG",
                "questionLevel": 1,
                "questionOptionType": "",
                "isMandatory": 1,
                "status": 1,
                "options": [
                  {
                    "questionId": 10,
                    "optionId": 8,
                    "optionDesc": "0-200",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 10,
                    "optionId": 9,
                    "optionDesc": "201-250",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 10,
                    "optionId": 10,
                    "optionDesc": "251-300",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 10,
                    "optionId": 11,
                    "optionDesc": "301 & above",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  }
                ]
              },
              {
                "matchId": 1,
                "tourId": 11125,
                "questionId": 21,
                "sportId": 1,
                "sportFormat": "cricket",
                "questionDesc": "Predict the number of runs in the powerplay",
                "questionType": "RNG",
                "questionLevel": 1,
                "questionOptionType": "",
                "isMandatory": 1,
                "status": 0,
                "options": [
                  {
                    "questionId": 21,
                    "optionId": 12,
                    "optionDesc": "0-30",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 21,
                    "optionId": 13,
                    "optionDesc": "31-40",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 21,
                    "optionId": 14,
                    "optionDesc": "41-50",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 21,
                    "optionId": 15,
                    "optionDesc": "51 & above",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  }
                ]
              },
              {
                "matchId": 1,
                "tourId": 11125,
                "questionId": 24,
                "sportId": 1,
                "sportFormat": "cricket",
                "questionDesc": "Team to win the match",
                "questionType": "TM",
                "questionLevel": 1,
                "questionOptionType": "",
                "isMandatory": 1,
                "status": 1,
                "options": [
                  {
                    "questionId": 24,
                    "optionId": 1,
                    "optionDesc": "Team 1",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 24,
                    "optionId": 2,
                    "optionDesc": "Team 2",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  },
                  {
                    "questionId": 24,
                    "optionId": 3,
                    "optionDesc": "Draw",
                    "optionType": "OPT",
                    "minValue": 1,
                    "maxValue": 10,
                    "isCorrect": 1,
                    "selectedPercent": 0
                  }
                ]
              }
            ],
            "feedTime": {
              "utCtime": "6/11/2020 9:38:50 AM",
              "isTtime": "11-06-2020 15:08:50"
            }
          },
          "meta": {
            "message": "Success",
            "retVal": 1,
            "success": true,
            "timestamp": {
              "utCtime": "6/11/2020 9:38:52 AM",
              "isTtime": "11-06-2020 15:08:52"
            }
          }
        }; */
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        arrQuestions = action.payload.data.data.value;
        if (
          config.enumMatchStatus.live.indexOf(jMdStatus) > -1 &&
          arrQuestions &&
          arrQuestions.length
        ) {
          arrQuestions.forEach((ele) => {
            const { publishedDate, questionTime, status } = ele;
            if (publishedDate && status === config.enumQuestionStatus.open) {
              let serverDateISO = action.payload.headers.date;
              let sDate = publishedDate;
              if (
                !(
                  publishedDate.indexOf("GMT") > -1 ||
                  publishedDate.indexOf("UTC") > -1
                )
              ) {
                sDate = sDate + " " + "GMT";
              }
              let dt = new Date(sDate);
              if (dt) {
                let objDate = new Date(
                  dt.setSeconds(dt.getSeconds() + Number(questionTime))
                );
                let mutatedDeadLineISO = objDate;
                let serverDates = new Date(serverDateISO);
                let mutatedDeadLine = new Date(mutatedDeadLineISO);
                let objDuration = core.daysBetween(
                  serverDates,
                  mutatedDeadLine
                );
                if (objDuration.ms_Diff < 0) {
                  ele.status = config.enumQuestionStatus.locked;
                }
              }
            }
          });
          const objLast = arrQuestions[arrQuestions.length - 1];
          // commented the code for show loader at last when matches is in Live State ...
          // if (!objLast.lastQstn) {
          //   //add on more row
          //   arrQuestions.push({
          //     questionId: config.jTempQuestionId,
          //     options: [],
          //     isNext: true,
          //     status: config.enumQuestionStatus.open,
          //   });
          // }
        }
      }
      return {
        ...state,
        isQuestionsLoading: false,
        isQuestionsError: false,
        isQuestionsSuccess: true,
        arrQuestions: arrQuestions,
      };
    }

    case FETCH_MTACH_USER_ANSWER_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isUsersAnswersLoading: true,
        isUsersAnswersError: false,
        isUsersAnswersSuccess: false,
      };
    }
    case FETCH_MTACH_USER_ANSWER_REJECTED: {
      return {
        ...state,
        isUsersAnswersLoading: false,
        isUsersAnswersError: true,
        isUsersAnswersSuccess: false,
      };
    }
    case FETCH_MTACH_USER_ANSWER_FULFILLED: {
      let objUsersAnswers = null;
      /* action.payload.data = {
          "data": {
            "value": {
              "matchId": 190851,
              "sportId": 1,
              "answers": [
                {
                  "questionId": 7,
                  "optionId": 10,
                  "points": 0,
                  "status": 0
                },
                {
                  "questionId": 4,
                  "optionId": 1,
                  "points": 0,
                  "status": 0
                }
              ],
              "booster1": 0,
              "booster2": 0
            },
            "feedTime": {
              "utCtime": "6/12/2020 11:59:26 AM",
              "isTtime": "12-06-2020 17:29:26"
            }
          },
          "meta": {
            "message": "Success",
            "retVal": 1,
            "success": true,
            "timestamp": {
              "utCtime": "6/12/2020 11:59:24 AM",
              "isTtime": "12-06-2020 17:29:24"
            }
          }
        } */
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        objUsersAnswers = action.payload.data.data.value;
      }
      return {
        ...state,
        isUsersAnswersLoading: false,
        isUsersAnswersError: false,
        isUsersAnswersSuccess: true,
        objUsersAnswers: objUsersAnswers,
      };
    }

    case POST_MTACH_USER_ANSWER_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isPostUsersAnswersLoading: true,
        isPostUsersAnswersError: false,
        isPostUsersAnswersSuccess: false,
      };
    }
    case POST_MTACH_USER_ANSWER_REJECTED: {
      return {
        ...state,
        isPostUsersAnswersLoading: false,
        isPostUsersAnswersError: true,
        isPostUsersAnswersSuccess: false,
      };
    }
    case POST_MTACH_USER_ANSWER_FULFILLED: {
      let objPostUsersAnswers = null;
      /* action.payload.data = {
          "data": {
            "value": {
              "matchId": 190851,
              "sportId": 1,
              "answers": [
                {
                  "questionId": 7,
                  "optionId": 10,
                  "points": 0,
                  "status": 0
                },
                {
                  "questionId": 4,
                  "optionId": 1,
                  "points": 0,
                  "status": 0
                }
              ],
              "booster1": 0,
              "booster2": 0
            },
            "feedTime": {
              "utCtime": "6/12/2020 11:59:26 AM",
              "isTtime": "12-06-2020 17:29:26"
            }
          },
          "meta": {
            "message": "Success",
            "retVal": 1,
            "success": true,
            "timestamp": {
              "utCtime": "6/12/2020 11:59:24 AM",
              "isTtime": "12-06-2020 17:29:24"
            }
          }
        } */
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        objPostUsersAnswers = action.payload.data.data.value;
      }
      return {
        ...state,
        isPostUsersAnswersLoading: false,
        isPostUsersAnswersError: false,
        isPostUsersAnswersSuccess: true,
        objPostUsersAnswers: objPostUsersAnswers,
      };
    }

    case POST_MTACH_USER_BOOSTER_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isPostUsersBoosterLoading: true,
        isPostUsersBoosterError: false,
        isPostUsersBoosterSuccess: false,
      };
    }
    case POST_MTACH_USER_BOOSTER_REJECTED: {
      return {
        ...state,
        isPostUsersBoosterLoading: false,
        isPostUsersBoosterError: true,
        isPostUsersBoosterSuccess: false,
      };
    }
    case POST_MTACH_USER_BOOSTER_FULFILLED: {
      let objPostUsersBooster = null;
      /* action.payload.data = {
          "data": {
            "value": {
              "matchId": 190851,
              "sportId": 1,
              "answers": [
                {
                  "questionId": 7,
                  "optionId": 10,
                  "points": 0,
                  "status": 0
                },
                {
                  "questionId": 4,
                  "optionId": 1,
                  "points": 0,
                  "status": 0
                }
              ],
              "booster1": 0,
              "booster2": 0
            },
            "feedTime": {
              "utCtime": "6/12/2020 11:59:26 AM",
              "isTtime": "12-06-2020 17:29:26"
            }
          },
          "meta": {
            "message": "Success",
            "retVal": 1,
            "success": true,
            "timestamp": {
              "utCtime": "6/12/2020 11:59:24 AM",
              "isTtime": "12-06-2020 17:29:24"
            }
          }
        } */
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        objPostUsersBooster = action.payload.data.data.value;
      }
      return {
        ...state,
        isPostUsersBoosterLoading: false,
        isPostUsersBoosterError: false,
        isPostUsersBoosterSuccess: true,
        objPostUsersBooster: objPostUsersBooster,
      };
    }

    case POST_CREATE_LEAGUE_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isPostCreateLeagueLoading: true,
        isPostCreateLeagueError: false,
        isPostCreateLeagueSuccess: false,
      };
    }
    case POST_CREATE_LEAGUE_REJECTED: {
      return {
        ...state,
        isPostCreateLeagueLoading: false,
        isPostCreateLeagueError: true,
        isPostCreateLeagueSuccess: false,
      };
    }
    case POST_CREATE_LEAGUE_FULFILLED: {
      let objPostCreateLeague = null;
      /* action.payload.data = {
          "data": {
            "value": {
              "matchId": 190851,
              "sportId": 1,
              "answers": [
                {
                  "questionId": 7,
                  "optionId": 10,
                  "points": 0,
                  "status": 0
                },
                {
                  "questionId": 4,
                  "optionId": 1,
                  "points": 0,
                  "status": 0
                }
              ],
              "booster1": 0,
              "booster2": 0
            },
            "feedTime": {
              "utCtime": "6/12/2020 11:59:26 AM",
              "isTtime": "12-06-2020 17:29:26"
            }
          },
          "meta": {
            "message": "Success",
            "retVal": 1,
            "success": true,
            "timestamp": {
              "utCtime": "6/12/2020 11:59:24 AM",
              "isTtime": "12-06-2020 17:29:24"
            }
          }
        } */
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        objPostCreateLeague = action.payload.data.data.value;
      }
      return {
        ...state,
        isPostCreateLeagueLoading: false,
        isPostCreateLeagueError: false,
        isPostCreateLeagueSuccess: true,
        objPostCreateLeague: objPostCreateLeague,
      };
    }

    case POST_JOIN_LEAGUE_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isPostJoinLeagueLoading: true,
        isPostJoinLeagueError: false,
        isPostJoinLeagueSuccess: false,
      };
    }
    case POST_JOIN_LEAGUE_REJECTED: {
      return {
        ...state,
        isPostJoinLeagueLoading: false,
        isPostJoinLeagueError: true,
        isPostJoinLeagueSuccess: false,
      };
    }
    case POST_JOIN_LEAGUE_FULFILLED: {
      let objPostJoinLeague = null;
      /* action.payload.data = {
          "data": {
            "value": {
              "matchId": 190851,
              "sportId": 1,
              "answers": [
                {
                  "questionId": 7,
                  "optionId": 10,
                  "points": 0,
                  "status": 0
                },
                {
                  "questionId": 4,
                  "optionId": 1,
                  "points": 0,
                  "status": 0
                }
              ],
              "booster1": 0,
              "booster2": 0
            },
            "feedTime": {
              "utCtime": "6/12/2020 11:59:26 AM",
              "isTtime": "12-06-2020 17:29:26"
            }
          },
          "meta": {
            "message": "Success",
            "retVal": 1,
            "success": true,
            "timestamp": {
              "utCtime": "6/12/2020 11:59:24 AM",
              "isTtime": "12-06-2020 17:29:24"
            }
          }
        } */
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        objPostJoinLeague = action.payload.data.data.value;
      }
      return {
        ...state,
        isPostJoinLeagueLoading: false,
        isPostJoinLeagueError: false,
        isPostJoinLeagueSuccess: true,
        objPostJoinLeague: objPostJoinLeague,
      };
    }

    case FETCH_USER_PLAYED_GAMEDAYS_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isUserPlayedGameDaysLoading: true,
        isUserPlayedGameDaysError: false,
        isUserPlayedGameDaysSuccess: false,
      };
    }
    case FETCH_USER_PLAYED_GAMEDAYS_REJECTED: {
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload &&
        action.payload.response &&
        action.payload.response.status
      ) {
        const jStatusCode = action.payload.response.status;
        jErrorcode = app.setErrorCode(jStatusCode);
      }
      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserPlayedGameDaysLoading: false,
        isUserPlayedGameDaysError: true,
        isUserPlayedGameDaysSuccess: false,
      };
    }
    case FETCH_USER_PLAYED_GAMEDAYS_FULFILLED: {
      let objUserPlayedGameDays = {};
      let matchIds = [];
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        matchIds = action.payload.data.data.value.matchId;
      }
      if (matchIds && matchIds.length) {
        for (let i = 0; i < matchIds.length; i++) {
          objUserPlayedGameDays[matchIds[i]] = {};
        }
      } else {
        objUserPlayedGameDays = null;
      }
      //core.setLoader();
      let jErrorcode = config.enumErrorCode.normal;
      if (
        action.payload.data &&
        action.payload.data.meta &&
        action.payload.data.meta.retVal
      ) {
        const jStatusCode = action.payload.data.meta.retVal;
        jErrorcode = app.setErrorCode(jStatusCode);
      }

      return {
        ...state,
        jErrorcode: jErrorcode,
        isUserPlayedGameDaysLoading: false,
        isUserPlayedGameDaysError: false,
        isUserPlayedGameDaysSuccess: true,
        objUserPlayedGameDays: objUserPlayedGameDays,
      };
    }

    case FETCH_CONTRAINTS_PENDING: {
      return {
        ...state,
        isContraintsLoading: true,
        isContraintsError: false,
        isContraintsSuccess: false,
      };
    }
    case FETCH_CONTRAINTS_REJECTED: {
      return {
        ...state,
        isContraintsLoading: false,
        isContraintsError: true,
        isContraintsSuccess: false,
      };
    }
    case FETCH_CONTRAINTS_FULFILLED: {
      let objContraints = null;
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        objContraints = action.payload.data.data.value;
      }
      return {
        ...state,
        isContraintsLoading: false,
        isContraintsError: false,
        isContraintsSuccess: true,
        objContraints: objContraints,
      };
    }

    case FETCH_MIX_PENDING: {
      return {
        ...state,
        isMixLoading: true,
        isMixError: false,
        isMixSuccess: false,
      };
    }
    case FETCH_MIX_REJECTED: {
      return {
        ...state,
        isMixLoading: false,
        isMixError: true,
        isMixSuccess: false,
      };
    }
    case FETCH_MIX_FULFILLED: {
      let objMix = null;
      if (
        action.payload.data &&
        action.payload.data.Data &&
        action.payload.data.Data.Value
      ) {
        objMix = action.payload.data.Data.Value;
      }
      /* //Testing
        let { jCount, arrFixtures } = state;
        if (!jCount) {
          jCount = 0;
        }
        if (jCount > 0) {
          const { api: arrAPI, ov } = objMix;
          if (arrAPI && arrAPI.length) {
            let obj = arrAPI.find((ele) => {
              return ele.nm === config.enumMixAPI.fixture;
            });
            obj.vn = '56789';
          }
        }
        ++jCount; 
        */
      return {
        ...state,
        isMixLoading: false,
        isMixError: false,
        isMixSuccess: true,
        objMix: objMix,
        /* //Testing
          jCount: jCount*/
      };
    }

    case FETCH_MTACH_USER_POINTS_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isUserPointsLoading: true,
        isUserPointsError: false,
        isUserPointsSuccess: false,
      };
    }
    case FETCH_MTACH_USER_POINTS_REJECTED: {
      return {
        ...state,
        isUserPointsLoading: false,
        isUserPointsError: true,
        isUserPointsSuccess: false,
      };
    }
    case FETCH_MTACH_USER_POINTS_FULFILLED: {
      /* action.payload.data = {
          "data": {
            "value": {
              "userid": "",
              "rankdetail": [{
                "matchId": 190851,
                "rank": 1,
                "points": 10
              },
              {
                "matchId": 190852,
                "rank": 1,
                "points": 10
              },
              {
                "matchId": 190853,
                "rank": 1,
                "points": 10
              }
              ]
            },
            "feedTime": {
              "utCtime": "6/18/20 6:22:32 AM",
              "isTtime": "6/18/20 11:52:32 AM"
            }
          },
          "meta": {
            "message": "Success",
            "retVal": 1,
            "success": true,
            "timestamp": {
              "utCtime": "6/18/20 6:22:32 AM",
              "isTtime": "6/18/20 11:52:32 AM"
            }
          }
        } */
      let { objUserPoints } = state;
      let objUserPointsMain = null;
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        const objUserPointsT = action.payload.data.data.value;
        if (
          objUserPoints &&
          objUserPoints.rankdetail &&
          objUserPoints.rankdetail.length
        ) {
          let rankdetailMian = [];
          for (let j = 0; j < objUserPoints.rankdetail.length; j++) {
            const objRank = objUserPoints.rankdetail[j];
            if (objRank) {
              rankdetailMian.push({ ...objRank });
            }
          }

          for (let j = 0; j < (objUserPointsT.rankdetail || []).length; j++) {
            const objRank = objUserPointsT.rankdetail[j];
            const jIndex = rankdetailMian.findIndex((objRow) => {
              return objRank.matchId === objRow.matchId;
            });
            if (objRank) {
              if (jIndex > -1) {
                rankdetailMian[jIndex] = { ...objRank };
              } else {
                rankdetailMian.push({ ...objRank });
              }
            }
          }
          objUserPointsMain = {
            ...objUserPointsMain,
            rankdetail: rankdetailMian,
          };
        } else {
          objUserPointsMain = objUserPointsT;
        }
      }
      return {
        ...state,
        isUserPointsLoading: false,
        isUserPointsError: false,
        isUserPointsSuccess: true,
        objUserPoints: objUserPointsMain,
      };
    }

    case FETCH_LEADERBOARD_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isLeaderboardLoading: true,
        isLeaderboardError: false,
        isLeaderboardSuccess: false,
      };
    }
    case FETCH_LEADERBOARD_REJECTED: {
      return {
        ...state,
        isLeaderboardLoading: false,
        isLeaderboardError: true,
        isLeaderboardSuccess: false,
      };
    }
    case FETCH_LEADERBOARD_FULFILLED: {
      /* action.payload.data = {"data":{"value":[{"UserId":"f348c030-c28d-11ea-b7c6-bd5bbdc851b6","FullName":"kanifnath","SocialId":"9099999999","SocialType":1,"Rank":1,"Points":391.0,"PageNo":1,"RowNo":1},{"UserId":"baae8c00-c28d-11ea-b7c6-bd5bbdc851b6","FullName":"MadMax","SocialId":"8989","SocialType":1,"Rank":2,"Points":235.0,"PageNo":1,"RowNo":2},{"UserId":"d14bc5d0-c28e-11ea-b7c6-bd5bbdc851b6","FullName":"omkar","SocialId":"8793704155","SocialType":1,"Rank":3,"Points":156.0,"PageNo":1,"RowNo":3},{"UserId":"491387b0-c28f-11ea-b7c6-bd5bbdc851b6","FullName":"","SocialId":"456456","SocialType":1,"Rank":3,"Points":156.0,"PageNo":1,"RowNo":4},{"UserId":"1ed15000-c28e-11ea-b7c6-bd5bbdc851b6","FullName":"","SocialId":"123321","SocialType":1,"Rank":5,"Points":154.0,"PageNo":1,"RowNo":5},{"UserId":"07aeeb30-c28e-11ea-b7c6-bd5bbdc851b6","FullName":"Asim","SocialId":"TechVerge","SocialType":1,"Rank":6,"Points":0.0,"PageNo":1,"RowNo":6},{"UserId":"0c2ad660-c28e-11ea-b7c6-bd5bbdc851b6","FullName":"Anirudh","SocialId":"007","SocialType":1,"Rank":6,"Points":0.0,"PageNo":1,"RowNo":7}],"feedTime":{"utCtime":"7/10/20 10:04:41 AM","isTtime":"7/10/20 3:34:41 PM"}},"meta":{"message":"","retVal":-40,"success":false,"timestamp":{"utCtime":"7/10/20 10:09:02 AM","isTtime":"7/10/20 3:39:02 PM"}}} */
      let arrLeaderboard = [];
      const { arrLeaderboardRank: arrLeaderboardRankT } = state;
      /* const {jC } = state;}
        if(jC)
        {
          action.payload.data = {"data":{"value":[{"UserId":"f348c030-c28d-11ea-b7c6-bd5bbdc851b6","FullName":"kanifnath","SocialId":"9099999999","SocialType":1,"Rank":1,"Points":491.0,"PageNo":1,"RowNo":1},{"UserId":"baae8c00-c28d-11ea-b7c6-bd5bbdc851b6","FullName":"MadMax","SocialId":"8989","SocialType":1,"Rank":2,"Points":435.0,"PageNo":1,"RowNo":2},{"UserId":"d14bc5d0-c28e-11ea-b7c6-bd5bbdc851b6","FullName":"omkar","SocialId":"8793704155","SocialType":1,"Rank":3,"Points":156.0,"PageNo":1,"RowNo":3},{"UserId":"491387b0-c28f-11ea-b7c6-bd5bbdc851b6","FullName":"","SocialId":"456456","SocialType":1,"Rank":3,"Points":156.0,"PageNo":1,"RowNo":4},{"UserId":"1ed15000-c28e-11ea-b7c6-bd5bbdc851b6","FullName":"","SocialId":"123321","SocialType":1,"Rank":5,"Points":154.0,"PageNo":1,"RowNo":5},{"UserId":"07aeeb30-c28e-11ea-b7c6-bd5bbdc851b6","FullName":"Asim","SocialId":"TechVerge","SocialType":1,"Rank":6,"Points":0.0,"PageNo":1,"RowNo":6},{"UserId":"0c2ad660-c28e-11ea-b7c6-bd5bbdc851b6","FullName":"Anirudh","SocialId":"007","SocialType":1,"Rank":6,"Points":0.0,"PageNo":1,"RowNo":7}],"feedTime":{"utCtime":"7/10/20 10:04:41 AM","isTtime":"7/10/20 3:34:41 PM"}},"meta":{"message":"","retVal":-40,"success":false,"timestamp":{"utCtime":"7/10/20 10:09:02 AM","isTtime":"7/10/20 3:39:02 PM"}}}
        } */
      let arrLeaderboardRank = [];
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        const arrLeaderboardT = action.payload.data.data.value.Users || [];
        const objCookie = app.getLoginCookie();
        let guid = objCookie ? objCookie.GUID : "0";
        arrLeaderboardT &&
          arrLeaderboardT.forEach((objLeaderboard) => {
            const { GUID } = objLeaderboard;
            if (guid === GUID) {
              arrLeaderboardRank.push({ ...objLeaderboard });
            }
          });
        arrLeaderboardRank &&
          arrLeaderboardRank.forEach((objLeaderboard) => {
            const { GUID } = objLeaderboard;
            if (guid === GUID) {
              arrLeaderboard.push({ ...objLeaderboard });
            }
          });
        arrLeaderboardT &&
          arrLeaderboardT.forEach((objLeaderboard) => {
            const { GUID } = objLeaderboard;
            if (guid !== GUID) {
              arrLeaderboard.push({ ...objLeaderboard });
            }
          });
      }
      return {
        ...state,
        isLeaderboardLoading: false,
        isLeaderboardError: false,
        isLeaderboardSuccess: true,
        arrLeaderboard: arrLeaderboard,
        arrLeaderboardRank: arrLeaderboardRank,
        // jC:1
      };
    }
    case FETCH_LEADERBOARD_RANK_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isLeaderboardRankLoading: true,
        isLeaderboardRankError: false,
        isLeaderboardRankSuccess: false,
      };
    }
    case FETCH_LEADERBOARD_RANK_REJECTED: {
      return {
        ...state,
        isLeaderboardRankLoading: false,
        isLeaderboardRankError: true,
        isLeaderboardRankSuccess: false,
      };
    }
    case FETCH_LEADERBOARD_RANK_FULFILLED: {
      let arrLeaderboardRank = null;
      let arrLeaderboardTotal = state.arrLeaderboard;
      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        arrLeaderboardRank = action.payload.data.data.value.Users || [];

        if (arrLeaderboardTotal) {
          const firstRow =
            arrLeaderboardRank && arrLeaderboardRank.length
              ? arrLeaderboardRank[0]
              : null;
          if (firstRow) {
            arrLeaderboardTotal.unshift({ ...firstRow });
          }
        }
      }
      return {
        ...state,
        isLeaderboardRankLoading: false,
        isLeaderboardRankError: false,
        isLeaderboardRankSuccess: true,
        arrLeaderboardRank: arrLeaderboardRank,
        arrLeaderboard: arrLeaderboardTotal,
      };
    }
    case FETCH_BALANCE_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isUserBalanceLoading: true,
        isUserBalanceError: false,
        isUserBalanceSuccess: false,
      };
    }
    case FETCH_BALANCE_REJECTED: {
      return {
        ...state,
        isUserBalanceLoading: false,
        isUserBalanceError: true,
        isUserBalanceSuccess: false,
      };
    }
    case FETCH_BALANCE_FULFILLED: {
      let objUserBalance = null;

      if (
        action.payload.data &&
        action.payload.data.data &&
        action.payload.data.data.value
      ) {
        objUserBalance = action.payload.data.data.value;
      }
      return {
        ...state,
        isUserBalanceLoading: false,
        isUserBalanceError: false,
        isUserBalanceSuccess: true,
        objUserBalance: objUserBalance,
      };
    }

    case CHANGE_SELECTED_FIXTURE: {
      let isSelectedFixtureT = true;
      const { arrFixtures, jFixtures } = state;
      const { jStatus, isSelectedFixture, matchdayId } = action.payload;
      let jFixturesT = jFixtures;
      isSelectedFixtureT = isSelectedFixture;
      if (isSelectedFixture) {
        jFixturesT = -1;
        for (let j = 0; j < (arrFixtures || []).length; j++) {
          let obj = arrFixtures[j];
          if (typeof matchdayId !== "undefined") {
            if (Number(matchdayId) === obj.TeamGamedayId) {
              jFixturesT = j;
              break;
            }
          } else {
            const jMdStatus = app.getFixtureStatusByRow(obj);
            if (jMdStatus === jStatus) {
              jFixturesT = j;
              break;
            }
          }
        }
      }
      return {
        ...state,
        isSelectedFixture: isSelectedFixtureT,
        jFixtures: jFixturesT,
      };
    }
    case SET_DATA_AFTER_POST: {
      let { objUsersAnswers, objUserPlayedGameDays } = state;
      const { questionId, optionId, boosterId, matchId, coinBet, isTemp } =
        action.payload;
      let coinBetT = 0;
      config.IS_BET && (coinBetT = coinBet);
      if (!objUsersAnswers) {
        objUsersAnswers = {};
        objUsersAnswers.answers = [];
      }
      let objUsersAnswersT = { ...objUsersAnswers };
      let arrAnswer = [];
      let isExist = false;
      if (!boosterId) {
        for (let j = 0; j < (objUsersAnswers.answers || []).length; j++) {
          let objAnswer = objUsersAnswers.answers[j];
          if (questionId === Number(objAnswer.questionId)) {
            isExist = true;
            objAnswer = { ...objAnswer, optionId, isTemp, coinBet: coinBetT };
            !optionId && (objAnswer = null);
          }
          objAnswer && arrAnswer.push({ ...objAnswer });
        }
        if (!isExist) {
          arrAnswer.push({ questionId, optionId, isTemp, coinBet: coinBetT });
        }
        objUsersAnswersT = { ...objUsersAnswersT, answers: arrAnswer };
        // console.log("answers ", objUsersAnswersT);
      }
      /* else {
          if (boosterId === config.enumBoosters.booster1) {
            objUsersAnswersT = { ...objUsersAnswersT, booster1: questionId };
            if (objUsersAnswersT.booster2 === questionId) {
              objUsersAnswersT = { ...objUsersAnswersT, booster2: 0 };
            }
          }
          else if (boosterId === config.enumBoosters.booster2) {
            objUsersAnswersT = { ...objUsersAnswersT, booster2: questionId };
            if (objUsersAnswersT.booster1 === questionId) {
              objUsersAnswersT = { ...objUsersAnswersT, booster1: 0 };
            }
          }
        } */
      let objUserPlayedGameDaysT = objUserPlayedGameDays;
      if (matchId) {
        const obj = objUserPlayedGameDays && objUserPlayedGameDays[matchId];
        if (obj) {
          objUserPlayedGameDaysT = {
            ...objUserPlayedGameDays,
            [matchId]: { quizCount: obj.quizCount ? obj.quizCount + 1 : 1 },
          };
        } else {
          objUserPlayedGameDaysT = {
            ...objUserPlayedGameDaysT,
            [matchId]: { quizCount: 1 },
          };
        }
      }
      return {
        ...state,
        objUsersAnswers: objUsersAnswersT,
        objUserPlayedGameDays: objUserPlayedGameDaysT,
        currQuestId: questionId,
      };
    }
    case SET_DATA_ALERT: {
      const { propsAlert } = action.payload;
      return {
        ...state,
        propsAlert: propsAlert,
      };
    }
    case CLEAR_DATA_QUESTIONS: {
      return {
        ...state,
        arrQuestions: [],
        objUsersAnswers: null,
      };
    }
    case SET_WRAPPER_REF: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case POST_LOGIN_PENDING: {
      //core.setLoader(true);
      return {
        ...state,
        isLoginLoading: true,
        isLoginError: false,
        isLoginSuccess: false,
      };
    }
    case POST_LOGIN_REJECTED: {
      return {
        ...state,
        isLoginLoading: false,
        isLoginError: true,
        isLoginSuccess: false,
      };
    }
    case POST_LOGIN_FULFILLED: {
      let objLogin = null;
      if (action.payload.data && action.payload.data.value) {
        objLogin = action.payload.data.value;
      }
      //core.setLoader();
      return {
        ...state,
        isLoginLoading: false,
        isLoginError: false,
        isLoginSuccess: true,
        objLogin: objLogin,
      };
    }
    case UPDATE_QUESTION_STATUS: {
      const { questionId, jStatus } = action.payload || {};
      const { arrQuestions, jStatusQuestionId } = state;
      let arrQuestionsM = [];
      let statusQuestionId = jStatusQuestionId;
      for (let j = 0; j < (arrQuestions || []).length; j++) {
        const objQuestion = arrQuestions[j];
        if (questionId === Number(objQuestion.questionId)) {
          arrQuestionsM.push({
            ...objQuestion,
            status:
              objQuestion.status === config.enumQuestionStatus.open
                ? jStatus
                : objQuestion.status,
          }); // config.enumQuestionStatus.locked
          if (objQuestion.status === config.enumQuestionStatus.open) {
            statusQuestionId = questionId;
          }
        } else {
          arrQuestionsM.push({ ...objQuestion });
        }
      }

      return {
        ...state,
        arrQuestions: arrQuestionsM,
        jStatusQuestionId: statusQuestionId,
      };
    }
    default: {
      return state;
    }
  }
}
